import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import {
  selectPrefix,
  selectWidth,
  selectreportFromDate,
  selectreportToDate,
  setreportsFromDate,
  setreportsTodate,
} from "../../utility/Redux/profile";
import { FromToDate } from "../../utility/component/fromToDate";
import { GetSaleSummary } from "./func";
import { selectToken } from "../../utility/Redux/security";
import { SummaryColumns } from "./columns";
import Footer from "./footer";
import { useReactToPrint } from "react-to-print";
import GeniusTableReports from "../../utility/component/geniusComponents/geniusTableData";
import { VoucherPrintColumns } from "./printColumns";
import VoucherPrint from "../../print/voucher";
import IsLocalData from "../../utility/component/isLocalData";
import FromToDateMobile from "../../utility/component/fromToDateMobile";
import GeniusTableForReports from "../../utility/component/printReport";
import NewPrintReport from "../../utility/component/datagrid/newPrintReport";
import { FormatNumber2 } from "../../utility/functions/formatNumber";

const PurchaseVoucherSummary = () => {
  const prefix = useSelector(selectPrefix);
  const [summaryList, setSummaryList] = useState([]);
  const fromDate = useSelector(selectreportFromDate);
  const ToDate = useSelector(selectreportToDate);
  const width = useSelector(selectWidth);
  const printRef = useRef(null);
  const [getCustomerData, setCustomerData] = useState({
    table_prefix: prefix,
    FDATE: moment(fromDate).format("YYYY-MM-DD"),
    TDATE: moment(ToDate).format("YYYY-MM-DD"),
  });
  const [voucherNo, setVoucherNo] = useState("");
  const printColumns = VoucherPrintColumns(width);
  const [refresh,setRefesh]=useState(false)
  const dispatch = useDispatch();
  const token = useSelector(selectToken);
  const okButton = () => {
    GetSaleSummary(getCustomerData, token, dispatch, setSummaryList);
  };
  const columns = SummaryColumns(width,okButton);

 
  const handlePrint = useReactToPrint({
    content: () => printRef.current,
    pageStyle: `
  @page {
    size: landscape;
  }
`,
  });

  useEffect(() => {
    setCustomerData((old) => {
      return {
        ...old,
        FDATE: moment(fromDate).format("YYYY-MM-DD"),
        TDATE: moment(ToDate).format("YYYY-MM-DD"),
      };
    });
  }, [fromDate, ToDate]);

  useEffect(() => {
    const callback = (details, data) => {
      setCustomerData(details[0]);
      setSummaryList(data);
      dispatch(setreportsFromDate(details[0].FDATE));
      dispatch(setreportsTodate(details[0].TDATE));
    };
    const elseFunc = () => {
      console.log("nothing");
    };
    IsLocalData("voucher_summary", callback, elseFunc);
  }, []);

  return (
    <div className=" bg-white flex flex-col h-full overflow-y-auto   ">
      <div className=" flex flex-col h-full p-3 ">
        <div>
          {window.innerWidth <= 700 ? (
            <>
              <FromToDateMobile onPrintClick={handlePrint} submit={okButton} />
            </>
          ) : (
            <FromToDate
              hideReset={true}
              onPrintClick={handlePrint}
              submit={okButton}
              reset={() => {
                setSummaryList([]);
              }}
            />
          )}
        </div>

        {summaryList[0] ? (
          <div
            style={{ height: `calc(100% - 0px)`, width: "100%", marginTop: 10 }}
            className=" mb-2  "
          >
            <GeniusTableReports
              onRowDoubleClick={(e) => {
                console.log("click");
                setVoucherNo(e.original.VOUCHER_NO);
              }}
              data={summaryList}
              columns={columns}
              footer={<Footer columns={columns} rows={summaryList} />}
            />

            <div className="w-full mt-3 ">
              <div
                style={{
                  display: "none",
                }}
              >
                <div ref={printRef}>
                <NewPrintReport
                    title={"Purchase Payment Summary"}
                    data={summaryList}
                    details={[
                      {
                        name: "From Date",
                        value: moment(fromDate).format("DD/MM/YYYY"),
                      },
                      {
                        name: "To Date",
                        value: moment(ToDate).format("DD/MM/YYYY"),
                      },
                    
                    ]}
                    columns={printColumns}
                    footer={
                      <Footer
                        isFeilds={
                          <div className="flex justify-end text-sm mt-2">
                            <div>
                              <div className="flex ">
                                <div className="font-semibold w-[160px] text-right ">
                                  Total Credit :
                                </div>
                                <div className="ml-2 flex flex-1 justify-end ">
                                  {FormatNumber2(
                                    summaryList.reduce(
                                      (acc, row) => acc + Number(row.CREDIT),
                                      0
                                    )
                                  )}
                                </div>
                              </div>

                              <div className="flex ">
                                <div className="font-semibold w-[160px] text-right ">
                                  Total Debit :
                                </div>
                                <div className="ml-2 flex flex-1 justify-end ">
                                  {FormatNumber2(
                                    summaryList.reduce(
                                      (acc, row) => acc + Number(row.DEBIT),
                                      0
                                    )
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        }
                        columns={printColumns}
                        rows={summaryList}
                      />
                    }
                  />
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div className="h-full flex justify-center items-center text-sm text-gray-400 border mt-3 rounded-sm">
            No Records Found
          </div>
        )}
      </div>

      <VoucherPrint IsVoucher={voucherNo} setVoucherNo={setVoucherNo} />
    </div>
  );
};

export default PurchaseVoucherSummary;
